export default __webpack_public_path__ + "static/media/breakfast1.fe4cbf63.png";